import { Badge } from "@/components/ui/badge";
import { Check, Clock, Banknote } from "lucide-react";
import { useTranslation } from "react-i18next";

const statusIcons: Record<string, typeof Check> = {
  paid: Check,
  pending: Clock,
  manual: Banknote,
  unpaid: Clock,
  refunded: Banknote,
  failed: Clock,
};

const statusClasses: Record<string, string> = {
  paid: "bg-green-500/10 text-green-700 border-green-200",
  pending: "bg-yellow-500/10 text-yellow-700 border-yellow-200",
  manual: "bg-blue-500/10 text-blue-700 border-blue-200",
  unpaid: "bg-muted text-muted-foreground",
  refunded: "bg-red-500/10 text-red-700 border-red-200",
  failed: "bg-red-500/10 text-red-700 border-red-200",
};

const statusKeys: Record<string, string> = {
  paid: "paidStatus",
  pending: "pendingStatus",
  manual: "manualPaid",
  unpaid: "unpaidStatus",
  refunded: "refundedStatus",
  failed: "failedStatus",
};

const METHOD_ICONS: Record<string, string> = {
  card: "\uD83D\uDCB3", stripe: "\uD83D\uDCB3", swish: "\uD83D\uDCF1", cash: "\uD83D\uDCB5",
  presentkort: "\uD83C\uDF81", epassi: "\uD83D\uDCF1", wellnet: "\uD83C\uDFCB\uFE0F", actiway: "\uD83C\uDFCB\uFE0F",
  invoice: "\uD83D\uDCC4", credits: "\uD83E\uDE99", wellness: "\uD83C\uDFCB\uFE0F",
};

export default function PaymentStatusBadge({ status, method }: { status: string; method?: string | null }) {
  const { t } = useTranslation("booking");
  const Icon = statusIcons[status] ?? statusIcons.unpaid;
  const className = statusClasses[status] ?? statusClasses.unpaid;
  const labelKey = statusKeys[status] ?? statusKeys.unpaid;
  const methodIcon = method ? METHOD_ICONS[method] : null;
  return (
    <Badge variant="outline" className={`gap-1 ${className}`}>
      {methodIcon ? <span className="text-xs">{methodIcon}</span> : <Icon className="h-3 w-3" />}
      {t(labelKey)}
    </Badge>
  );
}
